module.exports = __webpack_public_path__ + "static/media/markdown.99fe46f2.jpg";